import { useEffect } from 'react';
import { setIsOpened } from 'store/categorySlice';
import { useDispatch } from 'react-redux';
import { CategoryData } from '../models';

type UseCategoryAutoCompleteProps = {
  shouldTriggerAutoComplete: boolean;
  categoryToSelect: CategoryData | null;
  handleChange: (category: CategoryData) => void;
  delay: number;
};

export const useCategoryAutoComplete = ({
  shouldTriggerAutoComplete,
  categoryToSelect,
  handleChange,
  delay = 400,
}: UseCategoryAutoCompleteProps): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (shouldTriggerAutoComplete && categoryToSelect) {
      dispatch(setIsOpened(null));
      
      setTimeout(() => {
        handleChange(categoryToSelect);
      }, delay);
    }
  }, [
    shouldTriggerAutoComplete,
    categoryToSelect,
    handleChange,
    dispatch,
    delay
  ]);
};
